const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";

// yapi、dev、fat、stage、production
export const CLIENT_API = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "https://dev.huaban.com/v3",
  fat: "https://fat.huaban.com/v3",
  stage: "https://stage.huaban.com/v3",
  prod: "https://huaban.com/v3",
};

export const SERVER_API = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "http://api-dev.huaban.com",
  fat: "http://api-fat.huaban.com",
  stage: "https://api-stage.huaban.com",
  prod: "https://api.huaban.com",
};

export const BASE_URL =
  typeof window === "undefined" ? SERVER_API[env] : CLIENT_API[env];

export const BIZ_CODE = ["dev", "fat"].includes(env) ? "61" : "57";

export const BUSINESS_ID = "57";

export const CHANNEL_ID = "289";

export const GAODING_CHANNEL_ID = "32";
export const GAODING_BUSINESS_ID = "13";

export const ART_CHANNEL_ID_MAP = {
  yapi: 281,
  dev: 281,
  fat: 321,
  stage: 808,
  prod: 808,
};

export const ART_CHANNEL_ID = ART_CHANNEL_ID_MAP[env];
